import { WindowObj } from '@utils/windowObj';

export const isInIframe = () => {
    try {
        if (!__PROD__ && (window as any).UL_TEST_WEBVIEW) {
            // For testing only
            return false;
        }
        return WindowObj.self !== WindowObj.top;
    } catch (e) {
        return true;
    }
};
